import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import MasterPage from '../../../layouts/MasterPage';
import AuthenticationManager from '../../../services/StorageJWT';

const Main = () => {
  const auth = new AuthenticationManager();
  const navigate = useNavigate();

  const onHelp = (type) => {
    navigate('/one/helps', { state: { type: type } });
  };
  return (
    <MasterPage>
      <div className="structure-page login p-3 body ">
        <div className="game-one-main">
          <div className="row">
            <div className="col-4"></div>
            <div className="col-4 d-grid ">
              <img
                role="button"
                onClick={() => onHelp('nameh')}
                src="/images/steps/1.png"
                alt="نامه"
                className="img-fluid m-auto mb-2 "
              />
            </div>
            <div className="col-4"></div>
          </div>
          <div className="row">
            <div className="col-4">
              <img
                role="button"
                src="/images/steps/2.png"
                onClick={() => onHelp('compass')}
                alt="قطب نما"
                className="img-fluid m-auto mb-2 "
              />
            </div>
            <div className="col-4">
              <img
                src="/images/steps/3.png"
                onClick={() => onHelp('coins')}
                alt="سکه"
                className="img-fluid m-auto mb-2 "
              />
            </div>
            <div className="col-4">
              <img
                src="/images/steps/4.png"
                alt="مهر"
                onClick={() => onHelp('stamp')}
                className="img-fluid m-auto mb-2 "
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4"></div>
            <div className="col-4 ">
              <img
                src="/images/steps/5.png"
                alt=" نامه انگلیسی"
                onClick={() => onHelp('king')}
                className="img-fluid m-auto mb-2  "
              />
            </div>
            <div className="col-4"></div>
          </div>

          <div className="row justify-content-around ">
            <div className="col-4">
              <img
                src="/images/steps/6.png"
                alt="مکعب"
                onClick={() => onHelp('cube')}
                className="img-fluid m-auto mb-2 "
              />
            </div>

            <div className="col-4">
              <img
                src="/images/steps/7.png"
                alt="پارچه"
                onClick={() => onHelp('fabric')}
                className="img-fluid m-auto mb-2 "
              />
            </div>
          </div>
          <div className="row justify-content-around mb-3">
           
            <div className="col-4">
              <img
                role="button"
                src="/images/steps/8.png"
                alt="ریسمان"
                onClick={() => onHelp('robe')}
                className="img-fluid m-auto mb-2 "
              />
            </div>
            <div className="col-4">
              <img
                role="button"
                src="/images/steps/9.png"
                alt="نقشه"
                onClick={() => onHelp('map')}
                className="img-fluid m-auto mb-2 "
              />
            </div>
          </div>
        </div>
        {auth._token?.user?.status == 0 ? (
          <button
            onClick={() => navigate('/one/open')}
            className="btn btn-submit pt-2 pb-2 mb-4"
          >
            رمــز پایانـی
          </button>
        ) : (
          <button
            onClick={() => navigate('/one/home')}
            className="btn btn-back pt-2 pb-2 mb-4"
          >
           بازگـشـت
          </button>
        )}
      </div>
    </MasterPage>
  );
};
export default Main;
